import { useMediaQuery } from '@material-ui/core';

import theme from '../theme';

export const useGetIsPC = () => {
  return useMediaQuery(`(min-width:${theme.breakpoints.values['lg']}px)`);
};
